import { shouldHideEmbedCookieNotice } from "@lironsheli/website-content";

export function isEmbedContext(search = "") {
  if (typeof window !== "undefined" && window.self !== window.top) {
    return true;
  }

  const params = new URLSearchParams(
    search || (typeof window !== "undefined" ? window.location.search : "")
  );

  return params.get("embed") === "1";
}

export function shouldHideCookieNotice(settings = {}, embedMode = false) {
  if (!embedMode) {
    return false;
  }

  return shouldHideEmbedCookieNotice(settings, { embedMode: true });
}
